import qs from 'qs'
import { Query } from 'domain/models/query'

export const getQueryString = (query: Query) => {
  return qs.stringify(query, { arrayFormat: 'comma', encode: false })
}
